<template>
  <div>
    <b-card-code
      class="mt-2 principal"
    >
      <validation-observer ref="busValidation">
        <b-form @submit.prevent>
          <b-row class="mt-1 mb-1">
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Estado"
                rules="required"
              >
                <b-form-group
                  label-for="Estado"
                  :state="errors.length > 0 ? false:null"
                >
                  <label>Estado: <span class="text-danger">*</span></label>
                  <v-select
                    id="activo"
                    v-model="selectedEstado"
                    :options="estado"
                    :reduce="(option) => option.value"
                    label="text"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-marca"
              >
                <label>Marca: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Marca"
                  rules="required"
                >
                  <b-form-input
                    id="mc-marca"
                    v-model="marca"
                    placeholder="Marca"
                    :state="errors.length > 0 ? false:null"
                    name="marca"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-placa"
              >
                <label>Placa: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Placa"
                  rules="required|regex:^([A-Za-z]{3}[0-9]{4})*$"
                >
                  <b-form-input
                    id="mc-placa"
                    v-model="placa"
                    placeholder="AAAA1234"
                    name="placa"
                    maxlength="8"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-modelo"
              >
                <label>Modelo: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Modelo"
                  rules="required"
                >
                  <b-form-input
                    id="mc-modelo"
                    v-model="modelo"
                    placeholder="Modelo"
                    name="modelo"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-cantidad-pasajeros"
              >
                <label>Capacidad pasajeros: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Capacidad Pasajeros"
                  rules="required|integer"
                >
                  <b-form-input
                    id="mc-cantidad-pasajeros"
                    v-model="cantidad_pasajeros"
                    placeholder="Capacidad pasajeros"
                    name="cantidad_pasajeros"
                    type="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-disco"
              >
                <label>Disco: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Disco"
                  rules="required"
                >
                  <b-form-input
                    id="mc-disco"
                    v-model="disco"
                    placeholder="Disco"
                    name="disco"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 btn-guardar"
                size="sm"
                @click="validationForm"
              >
                <feather-icon
                  icon="SaveIcon"
                  size="16"
                  class="align-text-top"
                />
                <span>&nbsp;Guardar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'
import { required, integer } from '@validations'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import es from 'vee-validate/dist/locale/es.json'
import actions from "@/assets/utils/utils";
import $ from 'jquery'
import Vue from "vue";

localize({
  es,
})

localize('es')

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      login_user: '',

      marca: '',
      placa: '',
      modelo: '',
      cantidad_pasajeros: '',
      disco: '',
      token: '',
      activo: true,
      required,
      integer,

      selectedEstado: 'Activo',
      estado: [
        { value: 'Activo', text: 'Activo' },
        { value: 'Inactivo', text: 'Inactivo' },
      ],
    }
  },
  mounted() {
    if (this.$route.params.token) {
      this.token = this.$route.params.token
      this.getBus()
    } else {
      console.log('NO ENTRO')
    }
  },
  created() {
    this.comprobarPermisos()
    $('#btn-excel').remove()
    $('#btn-pdf').remove()
    $('#eliminar-viajes').remove()
    this.setToken()
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('log_bus_registrar') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    getBus() {
      axios.post('api', {
        query: `query busByToken($token: String!){
                    busByToken(tokenBus:$token){
                        bus{
                            placa,
                            marca,
                            modelo,
                            cantidad_pasajeros: cantidadPasajeros,
                            disco,
                            activo
                        },
                        status,
                        message
                    }
                }`,
        variables: {
          token: this.$route.params.token,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.busByToken.status === 'success') {
            const datos = response.data.data.busByToken.bus
            this.placa = datos.placa
            this.marca = datos.marca
            this.modelo = datos.modelo
            this.cantidad_pasajeros = datos.cantidad_pasajeros
            this.disco = datos.disco
            if (datos.activo === true) {
              this.selectedEstado = 'Activo'
            } else {
              this.selectedEstado = 'Inactivo'
            }
            actions.setearTitulo(this.placa)
          } else {
            this.$router.push({ name: 'error-404' })
          }
        }
      })
    },
    validationForm() {
      this.$refs.busValidation.validate().then(success => {
        if (success) {
          this.saveBus()
        }
      })
    },
    saveBus() {
      actions.bloquearBoton()
      this.activo = this.selectedEstado === 'Activo'
      axios.post('api', {
        query: `mutation createBus($marca: String!, $placa: String!, $modelo: String!, $cantidadPasajeros: Int!, $disco: String!, $token: String!, $activo: Boolean!){
                    createBus(marca:$marca, placa:$placa, modelo:$modelo, cantidadPasajeros:$cantidadPasajeros, disco:$disco, tokenBus: $token, activo: $activo)
                    {
                        bus{
                            token,
                            marca,
                            placa,
                            modelo,
                            cantidad_pasajeros: cantidadPasajeros,
                            disco,
                            activo,
                        }
                        status,
                        message,
                    }
                }`,
        variables: {
          marca: this.marca,
          placa: this.placa,
          modelo: this.modelo,
          cantidadPasajeros: this.cantidad_pasajeros,
          disco: this.disco,
          activo: this.activo,
          token: this.token,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.createBus.status === 'success') {
            const token = response.data.data.createBus.bus.token
            this.token = token
            this.showToast()
            if (this.$route.params.token) {
              console.log('')
            } else {
              this.$router.push({name: 'editbus', params: {token}})
            }
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.data.createBus.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        actions.desbloquearBoton()
      })
    },
    showToast() {
      this.$toast.success({
        component: ToastificationContent,
        props: {
          title: 'Bus',
          icon: 'InfoIcon',
          text: 'Se ha registrado con éxito un nuevo bus',
        },
      },
      {
        position: 'bottom-right',
      })
    },
    setToken() {
      const usuarioCookie = this.$cookie.get('usuario')
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie)
        this.login_user = user.username
        axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
      }
    },
  },
}
</script>
<style>
.principal .card-header{
    display: none !important
}
.principal .card-body{
    padding-bottom: 0 !important;
}
</style>
